/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wrapped_Muscles_Why_BodyInputs */

const en_us2_wrapped_muscles_why_body = /** @type {(inputs: Wrapped_Muscles_Why_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The dark line is your plan's weekly target.`)
};

const pt_br2_wrapped_muscles_why_body = /** @type {(inputs: Wrapped_Muscles_Why_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A linha escura é a meta semanal do seu plano.`)
};

const es_419_wrapped_muscles_why_body = /** @type {(inputs: Wrapped_Muscles_Why_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La línea oscura es la meta semanal de tu plan.`)
};

const pt_pt2_wrapped_muscles_why_body = /** @type {(inputs: Wrapped_Muscles_Why_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A linha escura é o objetivo semanal do teu plano.`)
};

const fr_fr2_wrapped_muscles_why_body = /** @type {(inputs: Wrapped_Muscles_Why_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La ligne foncée est l'objectif hebdomadaire de ton programme.`)
};

const de_de2_wrapped_muscles_why_body = /** @type {(inputs: Wrapped_Muscles_Why_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die dunkle Linie ist das Wochenziel deines Plans.`)
};

const it_it2_wrapped_muscles_why_body = /** @type {(inputs: Wrapped_Muscles_Why_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La linea scura è l'obiettivo settimanale della tua scheda.`)
};

/**
* | output |
* | --- |
* | "The dark line is your plan's weekly target." |
*
* @param {Wrapped_Muscles_Why_BodyInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const wrapped_muscles_why_body = /** @type {((inputs?: Wrapped_Muscles_Why_BodyInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wrapped_Muscles_Why_BodyInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_wrapped_muscles_why_body(inputs)
	if (locale === "es-419") return es_419_wrapped_muscles_why_body(inputs)
	if (locale === "pt-PT") return pt_pt2_wrapped_muscles_why_body(inputs)
	if (locale === "fr-FR") return fr_fr2_wrapped_muscles_why_body(inputs)
	if (locale === "de-DE") return de_de2_wrapped_muscles_why_body(inputs)
	if (locale === "it-IT") return it_it2_wrapped_muscles_why_body(inputs)
	return en_us2_wrapped_muscles_why_body(inputs)
});
export { wrapped_muscles_why_body as "wrapped.muscles_why_body" }